export default "__VITE_ASSET__CpfbLYJ4__"